export function checkUserProfileComplete(user) {
  if (!user) return false;

  // 通用必填
  const baseFields = ["loginname", "name", "phone", "identityval", "idendtime", "idcardfront", "idcardback", "signature"];

  // 教职人员额外字段
  const teacherFields = ["dhamaname", "proofname", "prooffile"];

  // 先校验基础字段
  for (let key of baseFields) {
    if (!user[key]) {
      return false;
    }
  }

  // 如果是教职人员（假设 role = teacher）
  if (user.membertype === 2) {
    for (let key of teacherFields) {
      if (!user[key]) {
        return false;
      }
    }
  }

  return true;
}

// 判断是否是移动端
export function Hc_IsMobile() {
  return /mobile/i.test(navigator.userAgent) || window.innerWidth < 768;
}

/**
 * HTML 转纯文本并截取指定长度
 * @param {String} html
 * @param {Number} maxLength
 */
export function Hc_Format_Html(html, maxLength = 100, options = {}) {
  if (!html) return "";

  const { keepLineBreak = false } = options;

  let text = "";

  try {
    // ✅ 用 DOM 解析 HTML（更安全可靠）
    const div = document.createElement("div");
    div.innerHTML = html;

    text = div.textContent || div.innerText || "";
  } catch (e) {
    // 兜底（极端情况）
    text = html
      .replace(/<style[\s\S]*?<\/style>/gi, "")
      .replace(/<script[\s\S]*?<\/script>/gi, "")
      .replace(/<\/?[^>]+>/g, "");
  }

  // ✅ 处理 HTML 实体 &nbsp; 等
  text = text
    .replace(/\u00a0/g, " ") // &nbsp;
    .replace(/&[a-z]+;/gi, " ");

  // ✅ 是否保留换行
  if (!keepLineBreak) {
    text = text.replace(/\s+/g, " ");
  } else {
    text = text.replace(/[ \t]+/g, " ");
  }

  text = text.trim();

  // ✅ 防止截断 emoji / 中文乱码
  const chars = Array.from(text);

  return chars.length > maxLength ? chars.slice(0, maxLength).join("") + "..." : text;
}

//节流
export const trottle = (func, time = 1000, context) => {
  let previous = new Date(0).getTime();
  return function(...args) {
    let now = new Date().getTime();
    if (now - previous > time) {
      func.apply(context, args);
      previous = now;
    }
  };
};

//获取url后的参数  以对象返回
export function strToParams(str) {
  var newparams = {};
  for (let item of str.split("&")) {
    newparams[item.split("=")[0]] = item.split("=")[1];
  }
  return newparams;
}

//对象参数转为以？&拼接的字符
export function paramsToStr(params) {
  let p = "";
  if (typeof params == "object") {
    p = "?";
    for (let props in params) {
      p += `${props}=${params[props]}&`;
    }
    p = p.slice(0, -1);
  }
  return p;
}

/**
 * @description 复制到剪切板
 * @param value { String } 复制内容
 * @return { Promise } resolve | reject
 */
export const copyClipboard = (value) => {
  const elInput = document.createElement("input");

  elInput.setAttribute("value", value);
  document.body.appendChild(elInput);
  elInput.select();

  try {
    if (document.execCommand("copy")) return Promise.resolve();
    else throw new Error();
  } catch (err) {
    return Promise.reject(err);
  } finally {
    document.body.removeChild(elInput);
  }
};

/**
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternalLink(path) {
  return /^(https?:|mailto:|tel:)/.test(path);
}

export function isObject(val) {
  return val !== null && typeof val === "object";
}

export function isString(val) {
  return typeof val === "string";
}



// WEBPACK FOOTER //
// ./src/tools/hc.js